(function () {
  'use strict';

  // Keyed by section wrapper element so multiple instances on one page work
  // and re-init in Theme Editor always targets the right one.
  const instances = new WeakMap();

  class AddonsShowcase {
    constructor(sectionEl) {
      this.el = sectionEl;
      this.mainSwiper = null;
      this.thumbSwiper = null;
      this._init();
    }

    _init() {
      const mainEl  = this.el.querySelector('.addons-showcase__swiper');
      const thumbEl = this.el.querySelector('.addons-showcase__thumbs-swiper');
      const prevBtn = this.el.querySelector('.addons-showcase__nav-prev');
      const nextBtn = this.el.querySelector('.addons-showcase__nav-next');

      if (!mainEl) return;

      const slides    = this.el.querySelectorAll('.addons-showcase__slide');
      const slideCount = slides.length;
      const isLooped  = slideCount > 3;

      if (thumbEl) {
        this.thumbSwiper = new Swiper(thumbEl, {
          slidesPerView: 3,
          spaceBetween: 15,
          centeredSlides: true,
          slideToClickedSlide: true,
          loop: isLooped,
          loopedSlides: slideCount,
          watchSlidesProgress: true,
          freeMode: false,
        });
      }

      const swiperConfig = {
        slidesPerView: 1,
        loop: isLooped,
        loopedSlides: slideCount,
        navigation: {
          prevEl: prevBtn || null,
          nextEl: nextBtn || null,
        },
      };

      this.mainSwiper = new Swiper(mainEl, swiperConfig);

      // Bidirectional controller — lets dragging the thumbs move the main slider
      if (this.thumbSwiper) {
        this.mainSwiper.controller.control  = this.thumbSwiper;
        this.thumbSwiper.controller.control = this.mainSwiper;
      }
    }

    // Called from shopify:block:select — slide to a specific index
    slideTo(index) {
      if (!this.mainSwiper) return;
      if (this.mainSwiper.params.loop) {
        this.mainSwiper.slideToLoop(index);
      } else {
        this.mainSwiper.slideTo(index);
      }
    }

    destroy() {
      if (this.mainSwiper)  { this.mainSwiper.destroy(true, true);  this.mainSwiper  = null; }
      if (this.thumbSwiper) { this.thumbSwiper.destroy(true, true); this.thumbSwiper = null; }
    }
  }

  function mountSection(sectionEl) {
    const existing = instances.get(sectionEl);
    if (existing) existing.destroy();
    const instance = new AddonsShowcase(sectionEl);
    instances.set(sectionEl, instance);
  }

  function initAll() {
    document.querySelectorAll('.section-addons-showcase').forEach(mountSection);
  }

  // ── Storefront init ───────────────────────────────────────
  // readyState check handles both normal page load (deferred script)
  // and any edge case where the script runs late.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // ── Theme Editor support ──────────────────────────────────
  if (window.Shopify && Shopify.designMode) {

    // Re-init when a section is added, moved, or its settings change
    document.addEventListener('shopify:section:load', function (e) {
      const sectionEl = e.target.querySelector('.addons-showcase__inner')
        ? e.target
        : null;
      if (sectionEl) mountSection(sectionEl);
    });

    // Slide to the block the merchant clicked in the sidebar
    document.addEventListener('shopify:block:select', function (e) {
      const slide = document.querySelector(
        '.addons-showcase__slide[data-id="' + e.detail.blockId + '"]'
      );
      if (!slide) return;

      const sectionEl = slide.closest('.section-addons-showcase');
      if (!sectionEl) return;

      const instance = instances.get(sectionEl);
      if (!instance) return;

      instance.slideTo(parseInt(slide.dataset.index, 10));
    });
  }
})();